import React, { useRef, useEffect } from 'react';
import SignaturePad from 'signature_pad';

interface SignatureCanvasProps {
    signataireName: string;
    signataireFunction?: string;
    onSignatureChange: (base64Png: string | null, type: 'texte' | 'dessin') => void;
}

export default function SignatureCanvas({
    signataireName,
    signataireFunction,
    onSignatureChange,
}: SignatureCanvasProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const padRef = useRef<SignaturePad | null>(null);

    useEffect(() => {
        if (!canvasRef.current) return;

        const canvas = canvasRef.current;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        const ctx = canvas.getContext('2d');
        if (ctx) ctx.scale(ratio, ratio);

        const pad = new SignaturePad(canvas, {
            penColor: '#1a1a2e',
            backgroundColor: 'rgba(255,255,255,0)',
        });

        pad.addEventListener('endStroke', () => {
            if (!pad.isEmpty()) {
                onSignatureChange(pad.toDataURL('image/png'), 'dessin');
            }
        });

        padRef.current = pad;

        return () => {
            pad.off();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClear = () => {
        padRef.current?.clear();
        onSignatureChange(null, 'dessin');
    };

    return (
        <div className="signature-canvas-container">
            <div className="signature-canvas-label">Votre signature</div>

            <div className="signature-canvas-area">
                <canvas ref={canvasRef} className="signature-canvas-pad" />
                <button
                    type="button"
                    className="signature-canvas-clear-btn"
                    onClick={handleClear}
                    title="Effacer"
                >
                    🗑️
                </button>
            </div>

            <div className="signature-canvas-identity">
                <span className="signature-canvas-name">{signataireName}</span>
                {signataireFunction && (
                    <span className="signature-canvas-function">{signataireFunction}</span>
                )}
            </div>
        </div>
    );
}
